import {Injectable} from "@angular/core";
import {DataService} from "../shared/data.service";
import {EMPTY, of} from "rxjs";
import {ApiEndpoints} from "../shared/ApiEndpoints";

@Injectable()
export class InfluxService extends DataService{

  query() {
    return this.postRequest(ApiEndpoints.influx, {});
  }
}
